export const MADE_WITH = 'Made with creators';
export const MADE_WITH_LONG = 'Made with creators, for creators.';
